import { CustomReportListItem } from './utils';

export const moduleName = 'customReports';

export enum CustomReportsTabs {
  MY_REPORTS = 'myReports',
  SHARED_REPORTS = 'sharedReports',
}

export type CustomReportsFilters = {
  memberIds: Record<string, boolean>;
};

export type CustomReportsSliceState = {
  customReportsActiveTab: CustomReportsTabs;
  sharedReportsActiveTab: string;
  sharedFilterModalOpen: Record<string, boolean>;
  sharedUnitRecordsFilters: Record<string, CustomReportsFilters>; // By sharedn unit
  selectedRowKeys: number[];
  sharedReportsSelectedRowKeys: Record<string, number[]>;
  sorter: {
    columnKey: keyof CustomReportListItem;
    order: 'ascend' | 'descend';
  };
};

export const initialSliceState: CustomReportsSliceState = {
  customReportsActiveTab: CustomReportsTabs.MY_REPORTS,
  sharedReportsActiveTab: '',
  sharedFilterModalOpen: {},
  sharedUnitRecordsFilters: {},
  selectedRowKeys: [],
  sharedReportsSelectedRowKeys: {},
  sorter: {
    columnKey: 'title',
    order: 'ascend',
  },
};
